import { Card } from '@/components/ui/card';
import { useTheme, type ThemePreference } from '@/providers/ThemeProvider';
import { useUpdateMe } from '@/features/settings/hooks';
import { cn } from '@/lib/utils';

const OPTIONS: Array<{ value: ThemePreference; label: string; hint: string }> = [
  { value: 'light', label: 'Claro', hint: 'Uso diurno' },
  { value: 'dark', label: 'Escuro', hint: 'Uso em ambiente de baixa luz' },
  { value: 'system', label: 'Sistema', hint: 'Acompanha o dispositivo' },
];

export function ThemePicker() {
  const { preference, setPreference } = useTheme();
  const update = useUpdateMe();

  const handleSelect = (value: ThemePreference) => {
    setPreference(value);
    update.mutate({ preferences: { theme: value } });
  };

  return (
    <Card>
      <div className="flex flex-col gap-3">
        <div>
          <h3 className="font-semibold">Tema</h3>
          <p className="text-sm text-(--color-fg-muted)">
            A preferência é salva no dispositivo e sincronizada com sua conta.
          </p>
        </div>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
          {OPTIONS.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => handleSelect(opt.value)}
              className={cn(
                'flex flex-col gap-1 rounded-md border p-3 text-left transition-colors',
                preference === opt.value
                  ? 'border-(--color-accent) bg-(--color-surface-elevated)'
                  : 'border-(--color-border) hover:bg-(--color-surface-elevated)',
              )}
              aria-pressed={preference === opt.value}
            >
              <span className="text-sm font-medium">{opt.label}</span>
              <span className="text-xs text-(--color-fg-muted)">{opt.hint}</span>
            </button>
          ))}
        </div>
      </div>
    </Card>
  );
}
